import { GraduationCap, BookOpen, Trophy, Briefcase } from 'lucide-react';

export const dacCourses = [
    {
        id: 'OSOPFoundation',
        title: 'Foundation Course (4 Years)',
        price: '90000',
        originalPrice: '150000',
        level: 'Beginner to Advanced',
        duration: '4 Years, Each Sem 3.5 Months',
        category: 'dac',
        lectures: '300+',
        mode: 'Live & Offline',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: 'Foundation',
            subtitle: '4 Years Program',
            background: 'bg-gradient-to-r from-emerald-600 to-teal-700',
            Icon: GraduationCap
        },
        description: 'A comprehensive training program for First year students to build solid programming foundation with Industry Ready skills.',
        overview: 'NO SELECTION? NO FEE!! A comprehensive training program for First year students to build solid programming foundation with Industry Ready skills. Become industry-ready through practical, job-oriented skills under the mentorship of Bajpai Sir. Each semester students can learn different skills. Students can choose from the variety of technical skill sets, build solid foundation on concept and explore the practical implementation of technical skills. 100% Job Guarantee Program for IT Aspirants.',
        highlights: [
            '100% Placement Backed Course with Money Back Gurantee',
            'Most Premium Course',
            'Live & Recorded Classes',
            'Assignments & Online Test',
            'Practical Approach',
            'Industry Recognised Certification',
            'Access to our Placement Portal'
        ],
        curriculum: [
            { 
                title: 'Year 1: Programming Fundamentals', 
                topics: [
                    'Introduction to Programming with C/C++',
                    'Python Programming',
                    'Problem Solving and Logic Building',
                    'DBMS/SQL'
                ] 
            },
            { 
                title: 'Year 2: DSA, Java & Web Development', 
                topics: [
                    'Advanced Data Structures and Algorithms',
                    'Core & Advance Java',
                    'Web Development Basics',
                    'Frontend Skills, HTML/CSS/JavaScript/React',
                ] 
            },
            { 
                title: 'Year 3: Specialization & Projects', 
                topics: [
                    'Software Engineering Principles',
                    'Java Spring Framework',
                    'MERN Stack Development',
                    'Cloud Computing Fundamentals',
                    'Minor Projects',
                    '1st Internship'
                ] 
            },
            { 
                title: 'Year 4: Industry Preparation', 
                topics: [
                    'Major Projects',
                    '2nd Internship',
                    'Interview Preparation',
                    'Mock Interview',
                    'Resume Building',
                    'Applying for Jobs'
                ] 
            }
        ]
    },
    {
        id: 'Target',
        title: 'Target Course (6 Months - 1 Year)',
        price: '99999',
        originalPrice: '149999',
        level: 'Intermediate to Advanced',
        duration: '6 Months - 1 Year',
        category: 'dac',
        lectures: '150+',
        mode: 'Live & Offline',
        language: 'Hindi/English',
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: 'Target',
            subtitle: '6 Months - 1 Year',
            background: 'bg-gradient-to-r from-blue-600 to-indigo-700',
            Icon: Trophy
        },
        description: 'An intensive training program for final year / pass outs students to build Industry Ready skills.',
        overview: 'An intensive training program for final year / pass outs students to build Industry Ready skills. Become industry-ready through practical, job-oriented skills under the mentorship of Bajpai Sir. Students can choose from the variety of technical skill sets, build solid concept and explore the practical implementation of technical skills. Become Industry ready with OSOP\'s Placement Support.',
        highlights: [
            'Most Premium Course',
            'Live & Recorded Classes',
            'Weekly Live Class for Doubt Solving',
            '50+ Assignments',
            'Assessment via Online Test',
            'Practical Approach',
            'Industry Recognised Certification Course',
            'Access to our Placement Portal'
        ],
        curriculum: [
            { 
                title: 'Months 1-2: Industry-Ready Programming', 
                topics: [
                    'Advanced Programming Concepts',
                    'System Design Fundamentals',
                    'Database Design and Optimization',
                    'API Development and Integration'
                ] 
            },
            { 
                title: 'Months 3-4: Full-Stack Development', 
                topics: [
                    'Frontend Frameworks (React/Angular)',
                    'Backend Development (Node.js/Spring Boot)',
                    'Cloud Services and Deployment',
                    'Testing and Quality Assurance'
                ] 
            },
            { 
                title: 'Months 5-6: Industry Projects & Placement', 
                topics: [
                    'Live Industry Projects',
                    'Portfolio Development',
                    'Interview Preparation',
                    'Soft Skills and Communication'
                ] 
            },
            { 
                title: 'Extended Program (7-12 Months): Specialization', 
                topics: [
                    'Advanced Specialization Tracks',
                    'Industry Internship',
                    'Advanced System Architecture',
                    'Leadership and Team Management'
                ] 
            }
        ]
    }
]; 